module.exports = __webpack_public_path__ + "static/contacto-bc28c811b6c5cfef25d83dc92492b2a0.png";